import ProfileRouter, { routeName } from './types';

const Calendar = () =>
  import('../views/calendar' /* webpackChunkName: "calendar" */);
const Webinars = () =>
  import('../views/webinars' /* webpackChunkName: "webinars" */);
const Lessons = () =>
  import('../views/lessons' /* webpackChunkName: "lessons" */);
const Examination = () =>
  import('../views/examination' /* webpackChunkName: "examination" */);
const ExaminationItem = () =>
  import('../views/examination-item' /* webpackChunkName: "examination" */);
const Tests = () => import('../views/tests' /* webpackChunkName: "tests" */);

const toName = (value: string) => [routeName.ROOT, value].join('-');

export const remoteEduRoutes = (redirect: void | null): Array<any> => {
  return [
    {
      path: 'calendar',
      component: Calendar,
      name: toName('calendar'),
      meta: {
        inpath:'profile-cabinet'
      },
      beforeEnter: redirect,
    },
    {
      path: 'webinars',
      component: Webinars,
      name: toName('webinars'),
      meta: {
        inpath:'profile-cabinet'
      },
      beforeEnter: redirect,
    },
    {
      path: 'lessons',
      component: Lessons,
      name: toName('lessons'),
      meta: {
        inpath:'profile-cabinet'
      },
      beforeEnter: redirect,
    },
    {
      path: 'examination',
      component: Examination,
      name: toName('examination'),
      meta: {
        inpath:'profile-cabinet'
      },
      beforeEnter: redirect,
    },
    {
      path: 'examination-item/:id/:groupId',
      component: ExaminationItem,
      name: toName('examination-item'),
      meta: {
        inpath:'profile-cabinet'
      },
      beforeEnter: redirect,
    },
    {
      path: 'tests',
      component: Tests,
      name: toName('tests'),
      meta: {
        inpath:'profile-cabinet'
      },
      beforeEnter: redirect,
    },
  ];
};

const createRoutes = ({ redirectTo404 }: ProfileRouter) =>
  remoteEduRoutes(redirectTo404);

export default createRoutes;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/router/index.ts